import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import AuthLayout from '@/views/Pages/AuthLayout.vue';
import NotFound from '@/views/GeneralViews/NotFoundPage.vue';

const Dashboard = () => import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard/Dashboard.vue');
const PriorAuth = () => import(/* webpackChunkName: "priorauth" */ '@/views/PriorAuth/PriorAuth.vue');
const Pricing = () => import(/* webpackChunkName: "pricing" */ '@/views/Pricing/Pricing.vue');
const PatientDashboard = () => import(/* webpackChunkName: "patient" */ '@/views/Patient/PatientDashboard.vue');
const Analytics = () => import(/* webpackChunkName: "analytics" */ '@/views/Analytics/Analytics.vue');
const UserProfile = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/UserProfile.vue');
const Login = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Login.vue');
const Home = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Home.vue');

let authPages = {
  path: '/',
  component: AuthLayout,
  name: 'Authentication',
  children: [
    {
      path: '/home',
      name: 'Home',
      component: Home,
      meta: {
        noBodyBackground: true
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    { path: '*', component: NotFound }
  ]
};

const routes = [
  {
    path: '/',
    redirect: '/dashboard',
    name: 'Home'
  },
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/dashboard',
    name: 'Dashboard layout',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta:{requiresAuth:true}
      },
      {
        path:'pa',
        name: 'Prior Authorizations',
        component: PriorAuth,
        meta:{requiresAuth:true}
      },
      {
        path:'patient',
        name: 'Patient Lookup',
        component: PatientDashboard,
        meta:{requiresAuth:true}
      },
      {
        path:'analytics',
        name: 'Analytics',
        component: Analytics,
        meta:{requiresAuth:true}
      },
      {
        path:'pricing/:category',
        component: Pricing,
        props:true,
        meta:{requiresAuth:true}
      },
      {
        path:'profile',
        name: 'Profile',
        component: UserProfile,
        meta:{requiresAuth:true}
      },
    ]
  },
  authPages
];

export default routes;
